import React, { useState } from "react";
import {  useRef } from "react";
import "../styles/InstilitWebpage.css";
import { FaLinkedin } from 'react-icons/fa';
import { useNavigate } from "react-router-dom";
 import { FaRegCalendarAlt, FaVideo, FaBriefcaseMedical } from 'react-icons/fa';

const InstilitWebpage = () => {
 const curriculumHighlights = [
  "Introduction to Data Science & Python Programming",
  "Statistics & Data Wrangling Essentials",
  "Exploratory Data Analysis & Visualization Techniques",
  "Supervised & Unsupervised Machine Learning Models",
  "Hands-On Projects with Pandas, NumPy & Scikit-learn",
  "SQL for Data Analysis & Business Intelligence"
];

const benefits = [
  "Learn Data Science Tools Used by Top Companies",
  "Get Industry-Ready in Just 4 Months",
  "Perfect for Beginners Looking to Start Strong",
  "Led by Experienced Data Scientists & Mentors",
  "Lifetime Access at an Unbeatable Price"
];

const programHighlights = [
  {
    title: "Data Science Foundations",
    detail: "Grasp statistics, data wrangling, and basic Python for analysis.",
    detail2: "Build a strong foundation in exploratory data analysis and visualization."
  },
  {
    title: "Core Techniques",
    detail: "Dive into supervised and unsupervised machine learning algorithms.",
    detail2: "Apply key concepts like regression, classification, clustering, and feature engineering."
  },
  {
    title: "Real-World Projects",
    detail: "Work on hands-on projects using real datasets in guided sessions.",
    detail2: "Use tools like Pandas, Scikit-learn, and SQL to build data-driven solutions."
  },
  {
    title: "Career Development",
    detail: "Create a professional portfolio with capstone-ready projects.",
    detail2: "Strengthen your resume and prepare for interviews with expert guidance."
  }
];

  const navigate = useNavigate();
const formRef = useRef(null);

  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    contact_number: "",
    course_name: "Data Science"
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.id]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch("https://api.instilit.com/api/register-course/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(formData)
      });
      if (response.ok) {
        navigate("/thank-you");
      } else {
        alert("Registration failed. Please try again.");
      }
    } catch (error) {
      alert("Error occurred while submitting the form.");
    }
  };
 const scrollToForm = () => {
  if (formRef.current) {
    formRef.current.scrollIntoView({ 
      behavior: "smooth",
      block: "center" 
    });
  }
};
  return (
    <div className="instilit-container">
      <section 
        className="hero-section"
        style={{
          backgroundImage: "url('/images/background2.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          color: "white"
        }}

      >
   <div className="md:hidden fixed right-0 bottom-20 z-50">
  <button
    onClick={scrollToForm}
    className="bg-blue-600 hover:bg-blue-700 text-white font-bold shadow-lg transition-all duration-300 flex items-center justify-center"
    style={{
      writingMode: "vertical-rl",
      textOrientation: "mixed",
      height: "110px",
      width: "32px",
      padding: "0.5rem",
      borderRadius: "0.375rem 0 0 0.375rem",
      fontSize: "0.8rem",
      letterSpacing: "0.5px"
    }}
  >
    Enroll Now
  </button>
</div>
        <div className="hero-wrapper">
          <div className="course-details">
            <div className="certificate-container">
              <button className="certificate-btn">
                <img src="/images/logo2.jpg" alt="Certificate" className="certificate-img hidden sm:block" />
              </button>
            </div>
            <div className="course-content">
              <h1 className="course-title">Full Stack Data Science Course with GEN AI Primer</h1>
              <p className="course-subtitle">Build a career in the most in-demand tech field!</p>
              <ul className="course-features">
                <li>📅 <span className="session-time">Enroll by 18th July:</span> New Batch Starts on 21st July | Timings: 7:00 AM – 8:30 AM IST</li>
                <li>🧠 Capstone Project: Apply your data science skills to a real-world challenge for hands-on experience</li>
                <li>💼 Career Support: Lifetime access to course content and 100% placement assistance to kickstart your analytics career</li>
              </ul>
               {/* <a
              href=""
              className="hero-button"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className="strikethrough">₹30,000</span>
              ₹25,000/-
            </a> */}
           <div className="hero-button1">
  {/* <span className="strikethrough">₹30,000</span> */}
  Only ₹25,000/-
</div>
            </div>
          </div>
          
          <div className="registration-form-container" ref={formRef}>
            <form className="registration-form" onSubmit={handleSubmit}>
              <h2 className="form-title">🚀 Register for Data Science Course</h2>
              
              <div className="form-group">
                <label htmlFor="first_name">First Name</label>
                <input
                  id="first_name"
                  value={formData.first_name}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="last_name">Last Name</label>
                <input
                  id="last_name"
                  value={formData.last_name}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">Email Address</label>
                <input
                  type="email"
                  id="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="contact_number">Contact Number</label>
                <input
                  type="tel"
                  id="contact_number"
                  value={formData.contact_number}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="course_name">Course Name</label>
                <input
                  id="course_name"
                  value={formData.course_name}
                  onChange={handleChange}
                  disabled
                />
              </div>

              <button type="submit" className="submit-btn">
                 Enroll Now
              </button>
            </form>
          </div>
        </div>
      </section>

      
      
       <section className="program-highlights">
        <h2 className="section-title">Program Highlights</h2>
        <div className="cards-container">
          {programHighlights.map((highlight, index) => (
            <div key={index} className="highlight-card">
              <h3 className="card-title">{highlight.title}</h3>
              <ul>
                <li className="card-detail">{highlight.detail}</li>
                <li className="card-detail">{highlight.detail2}</li>
              </ul>
            </div>
          ))}
        </div>
      </section>

      {/* Curriculum & Benefits */}
      <section className="curriculum-section">
        <div className="two-column-container">
          <div className="column">
            <h2 className="section-title">Curriculum</h2>
            <ul className="feature-list">
              {curriculumHighlights.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>
          <div className="column">
            <h2 className="section-title">Benefits</h2>
            <ul className="feature-list">
              {benefits.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      
           <div className="timeline-title"> Course Timeline</div>
      <div className="timeline-container">
        
        <div className="timeline">
     
          <div className="timeline-step top-content">
            <div className="timeline-icon calendar-icon">
              <FaRegCalendarAlt size={24} />
            </div>
            <div className="timeline-content">
              <h3>Batch Starts</h3>
              <p> July 16th, 2025</p>
            </div>
          </div>

          <div className="timeline-step bottom-content">
            <div className="timeline-icon video-icon">
              <FaVideo size={20} />
            </div>
            <div className="timeline-content">
              <h3>Live Online Sessions</h3>
              <p>4 months of immersive Data Science training</p>
            </div>
          </div>

          <div className="timeline-step top-content">
            <div className="timeline-icon internship-icon">
              <FaBriefcaseMedical size={24} />
            </div>
            <div className="timeline-content">
              <h3>Projects & Career Prep</h3>
              <p>Apply your skills to a real-world</p>
            </div>
          </div>
        </div>
      </div>
      {/* Mentor Section */}
      <section className="mentor-section">
        <div className="mentor-card">
          <div className="mentor-image">
            <img src="/images/Mentor.png" alt="Sharat Manikonda" />
          </div>
          <div className="mentor-info">
            <h2 className="mentor-title">Meet Your Mentor</h2>
            <div className="mentor-header">
              <h3 className="mentor-name">Sharat Manikonda</h3>
              <a href="https://www.linkedin.com/in/sharat-manikonda/" className="linkedin-link">
                <FaLinkedin className="linkedin-icon" />
              </a>
            </div>
            <p className="mentor-role">AI, ML, Data Science, Data Engineering, MLOps</p>
            <p className="mentor-bio">
              With over 19 years of experience in Industry with expertise in data science, artificial intelligence, and business analytics, Sharat Manikonda, Founder and MD Instilit, Director of Analytics at Innodatatics, AI Partner & Design Architect for Doing ERP.
            </p>
            <p className="mentor-bio">
              His extensive knowledge spans machine learning, deep learning, artificial intelligence, and business intelligence, backed by a strong foundation in technology and business strategy.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default InstilitWebpage;